import { memo, ReactNode, Suspense, useMemo } from 'react';
import { useLocation } from 'react-router';
import { Route } from 'react-router-dom';
import { UtilsGlobalCasino } from 'utils/casino';
import { GLOBALS } from 'utils/generic/global-variables';
import { lazy as lazyImport } from 'utils/generic/lazy';
import { mountPoint } from 'utils/generic/route-manipulation';
import { isMobile } from 'utils/is-mobile';
import { ConstantsCasino } from './__partials/constants';
import { GameViewContainer } from './__partials/GameViewContainer';
import { UtilsCasino } from './__partials/GameViewContainer/utils';
import { useCsOldRouteChecker } from './__partials/hooks/useCsOldRouteChecker';
import { SingleviewOuterManager } from 'newelements/Casino/GameSingleViewRenderer/__partials/GameViewContainer/managers/SingleviewOuterManager';
import { QueryRoute } from 'components/QueryRoute';
import { Portal } from 'components/Shared/Portal';

const { CasinoGamePreview } = lazyImport(
  () =>
    import(
      /* webpackChunkName: "casino-game-preview" */ 'components/CasinoItemPreview/CasinoGamePreview'
    )
);

export const CasinoGameSingleViewRenderer = memo((): ReactNode => {
  useCsOldRouteChecker();
  const location = useLocation();
  const isCasinoSingleViewRoute = UtilsGlobalCasino.isCasinoSingleViewRoute();

  const pathName = mountPoint(window.getPathname(), false, true) as string;
  const routeLength = useMemo(
    () => UtilsCasino.getRouteLength(),
    [location.search, location.pathname]
  );

  /**  RETURN IF THE PAGE NEEDS TO RELOAD FOR SESSION VISIBILITY **/

  if (GLOBALS.casino.blockCasinoGamePopupOpening) {
    return null;
  }

  return (
    <>
      {isCasinoSingleViewRoute &&
        routeLength !== ConstantsCasino.ROUTE_LENGTH_WITHOUT_PROVIDER && (
          <SingleviewOuterManager />
        )}
      {isMobile() &&
      routeLength === ConstantsCasino.ROUTE_LENGTH_WITHOUT_PROVIDER ? (
        <QueryRoute
          excludes={['mode']}
          render={() => (
            <Route path={`${pathName}/:category/:gameCategory/:game`}>
              <Suspense fallback={null}>
                <CasinoGamePreview />
              </Suspense>
            </Route>
          )}
        />
      ) : null}

      {routeLength !== undefined &&
      routeLength !== ConstantsCasino.ROUTE_LENGTH_WITHOUT_PROVIDER ? (
        <Route path={`${pathName}/:category?/:gameCategory?/:provider?/:game?`}>
          <QueryRoute
            includes={[['mode'], ['multiview']]}
            render={() => <GameViewContainer />}
          />
        </Route>
      ) : (
        <QueryRoute
          includes={[['gameId', 'mode'], ['multiview']]}
          render={() => <GameViewContainer />}
        />
      )}

      {isMobile() && (
        <QueryRoute
          includes={['gameId']}
          excludes={['mode', 'key']}
          render={() => (
            <Portal>
              <CasinoGamePreview />
            </Portal>
          )}
        />
      )}
    </>
  );
});
